import { PatchworkApiError, PatchworkRESTApiError } from "../apireturncodes";
import { Result } from "../../engine/types/result";
import { apiGet, apiPost, apiDelete } from "../apiutils";
import type { UserGameSaveModel } from "../../models/usergamesave";

export function login(log : string, password : string) : Promise<Result<boolean>> {
	var postData = {
		email : "",
		username : "",
		password : password
	};
	if( /(.+)@(.+){2,}\.(.+){2,}/.test(log) ){
		postData.email = log;
	} else {
		postData.username = log;
	}
	return apiPost(
        "/api/user/login",
		postData,
		true
	)
	.then(async res => {
		var r = res.unpack();
		if (r) {
			if (r.ok) {
				return Result.makeSuccess<boolean>(true);
			}
			return Result.makeError<boolean>(new PatchworkRESTApiError((await r.json()) as PatchworkApiError));
		}
		return Result.makeError<boolean>(res.error()!);
	}).catch(err => {
		return Result.makeError<boolean>(err);
	});
}


export function register(mail : string, username : string, password : string) : Promise<Result<boolean>> {
    return fetch(
        "/api/user/register",
        {
            method : "POST",
            body : JSON.stringify({email : mail, username : username, password : password}),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
		.then(async r => {
			if (r.ok) {
				return Result.makeSuccess<boolean>(true);
			}
			return Result.makeError<boolean>(new PatchworkRESTApiError(await r.json() as PatchworkApiError))
		})
		.catch(err => {
			console.error(err);
			return Result.makeError<boolean>(err);
		});
}

export function verifyEmail(validationId : string) : Promise<Result<boolean>> {
	return fetch(
		"/api/user/verify-email",
		{
			method : "POST",
			headers : {
				'Accept' : 'application/json',
				'Content-Type' : 'application/json'
			},
			body : JSON.stringify({ mailValidationUuid: validationId })
		})
		.then(async (r) => {
			if (r.ok) {
				return Result.makeSuccess<boolean>(true);
			}
			return Result.makeError<boolean>(new PatchworkRESTApiError(await r.json() as PatchworkApiError));
		})
		.catch((err) => {
			console.error(err);
			return Result.makeError<boolean>(new Error("Error whil verifying email"));
		});
}

export function logout() : Promise<Result<boolean>> {
	return apiPost(
		"/api/user/logout",
		{},
		true)
		.then(async (r) => {
			var response = r.unpack();
			if (response) {
				if (response.ok) {
					return Result.makeSuccess(true);
				}
				return Result.makeError<boolean>(new PatchworkRESTApiError(await response.json() as PatchworkApiError));
			}
			return Result.makeError<boolean>(r.error()!);
		})
		.catch(err => {
			console.error(err);
			return Result.makeError<boolean>(err);
		});
}


export function logoutAllDevice() : Promise<Result<boolean>> {
	return apiPost(
		"/api/user/logout/all",
		{},
		true)
		.then(async (r) => {
			var response = r.unpack();
			if (response) {
				if (response.ok) {
					return Result.makeSuccess(true);
				}
				return Result.makeError<boolean>(new PatchworkRESTApiError(await response.json() as PatchworkApiError));
			}
			return Result.makeError<boolean>(r.error()!);
		})
		.catch(err => {
			console.error(err);
			return Result.makeError<boolean>(err);
		});
}

export function deleteUser() : Promise<Result<boolean>> {
	return apiDelete(
		"/api/user/delete",
		{},
		false)
		.then(async (r) => {
			var response = r.unpack();
			if (response) {
				if (response.ok) {
					return Result.makeSuccess(true);
				}
				return Result.makeError<boolean>(new PatchworkRESTApiError(await response.json() as PatchworkApiError));
			}
			return Result.makeError<boolean>(r.error()!);
		})
		.catch(err => {
			console.error(err);
			return Result.makeError<boolean>(err);
		});
}


export function listGameSaves() : Promise<Result<Array<UserGameSaveModel>>> {
	return apiGet(
		"/api/user/games/save/list",
		true)
		.then(async (r) => {
			var response = r.unpack();
			if (response) {
				if (response.ok) {
					return Result.makeSuccess(await response.json() as Array<UserGameSaveModel>);
				}
				return Result.makeError<Array<UserGameSaveModel>>(new PatchworkRESTApiError(await response.json() as PatchworkApiError));
			}
			return Result.makeError<Array<UserGameSaveModel>>(r.error()!);
		})
		.catch(err => {
			console.error(err);
			return Result.makeError<Array<UserGameSaveModel>>(err);
		});
}

export function resetGameSave(saveModel: UserGameSaveModel) : Promise<Result<boolean>> {
	return apiPost(
		"/api/user/games/save/reset",
		saveModel,
		true)
		.then(async (r) => {
			var response = r.unpack();
			if (response) {
				if (response.ok) {
					return Result.makeSuccess(true);
				}
				return Result.makeError<boolean>(new PatchworkRESTApiError(await response.json() as PatchworkApiError));
			}
			return Result.makeError<boolean>(r.error()!);
		})
		.catch(err => {
			console.error(err);
			return Result.makeError<boolean>(err);
		});
}

export function passwordForgot(email: string) : Promise<Result<boolean>> {
	var postData = {
		email : email
	};
	return apiPost(
		"/api/user/forgot-password",
		postData,
		false)
		.then(async (r) => {
			var response = r.unpack();
			if (response) {
				if (response.ok) {
					return Result.makeSuccess(true);
				}
				return Result.makeError<boolean>(new PatchworkRESTApiError(await response.json() as PatchworkApiError));
			}
			return Result.makeError<boolean>(r.error()!);
		})
		.catch(err => {
			console.error(err);
			return Result.makeError<boolean>(err);
		});
}

export function resetPassword(uuid: string, email: string, password : string) : Promise<Result<boolean>> {
	var postData = {
		uuid : uuid,
		email : email,
		password : password
	};
	return apiPost(
		"/api/user/reset-password",
		postData,
		false)
		.then(async (r) => {
			var response = r.unpack();
			if (response) {
				if (response.ok) {
					return Result.makeSuccess(true);
				}
				return Result.makeError<boolean>(new PatchworkRESTApiError(await response.json() as PatchworkApiError));
			}
			return Result.makeError<boolean>(r.error()!);
		})
		.catch(err => {
			console.error(err);
			return Result.makeError<boolean>(err);
		});
}

export function updatePassword(currentPassword: string, newPassword: string) : Promise<Result<boolean>> {
	var postData = {
		currentPassword : currentPassword,
		newPassword : newPassword
	};
	return apiPost(
		"/api/user/update-password",
		postData,
		true
	)
	.then(async res => {
		var r = res.unpack();
		if (r) {
			if (r.ok) {
				return Result.makeSuccess<boolean>(true);
			}
			return Result.makeError<boolean>(new PatchworkRESTApiError((await r.json()) as PatchworkApiError));
		}
		return Result.makeError<boolean>(res.error()!);
	}).catch(err => {
		return Result.makeError<boolean>(err);
	});
}

export function resendValidationMail(email : string) : Promise<Result<boolean>> {
	return fetch(
		"/api/user/resend-verification-email",
		{
			method : "POST",
			headers : {
				'Accept' : 'application/json',
				'Content-Type' : 'application/json'
			},
			body : JSON.stringify({ email: email })
		})
		.then(async (r) => {
			if (r.ok) {
				return Result.makeSuccess<boolean>(true);
			}
			return Result.makeError<boolean>(new PatchworkRESTApiError(await r.json() as PatchworkApiError));
		})
		.catch((err) => {
			console.error(err);
			return Result.makeError<boolean>(new Error("Error whil verifying email"));
		});
}
